import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { showErrors } from "actions/general.action";
import { getPayementTypesSuccess } from "actions/paymentType.action";
import { FETCH_PAYMENT_TYPES } from "../constants/payementType.constants";

// get payment types
const fetchPaymentTypesRequest = async (page) => {
  let link = "/api/v1/super_admin/payment_types";
  if (page) {
    link = `/api/v1/super_admin/payment_types?page=${page}`;
  }
  return axios.get(link);
};

function* fetchPaymentTypes({ page }) {
  try {
    const result = yield call(fetchPaymentTypesRequest, page);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getPayementTypesSuccess(result.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

export function* forkFetchPaymentTypes() {
  yield takeEvery(FETCH_PAYMENT_TYPES, fetchPaymentTypes);
}

export default function* rootSaga() {
  yield all([fork(forkFetchPaymentTypes)]);
}
